// Canonical Drive roots for the consolidated filing structure
// (superseding the old scattered AHFC Patient Records / Staff Records paths).
// New uploads should always target these, keyed by the client's G-number or
// staff's E-number -- never a name, never a UUID.
export const CLIENT_DRIVE_ROOT = '1D3t6uDP7w74x7DJLBSaVoFrQB8RRtKI5'; // "6 - Client Folder"
export const STAFF_DRIVE_ROOT = '19Yf6DgjQgeHBZ1NVt6stqbyUN2YXlN8W';  // "5 - Staff Folder"

export const driveFolderUrl = (folderId) =>
  folderId ? `https://drive.google.com/drive/folders/${folderId}` : null;

// Standard subfolders a client/staff document can be filed under.
export const CLIENT_DOC_BUCKETS = [
  'Assessments', 'Supervisor Visits', 'Signing Packets',
  'Authorizations', 'Medical Records', 'Eligibility & Insurance',
  'DME', 'Correspondence', 'Faxes', 'Needs Review',
];
export const STAFF_DOC_BUCKETS = [
  'Onboarding', 'Training & Compliance', 'Agreements', 'Payroll',
  'Personnel', 'Needs Review',
];

// Creates (or finds) a client's/staff member's canonical Drive folder right
// now, rather than waiting for the first document. Call this the moment a
// client is created or a staff member actually goes active -- idempotent,
// safe to call more than once for the same entity. Returns the folder id, or
// null if it failed (never throws -- folder creation is a nice-to-have here,
// never something that should block saving the underlying record).
export async function ensureEntityFolder(entityType, entityId) {
  try {
    const res = await fetch(`${process.env.REACT_APP_SUPABASE_URL}/functions/v1/ensure-entity-folder`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`,
        apikey: process.env.REACT_APP_SUPABASE_ANON_KEY,
      },
      body: JSON.stringify({ entityType, entityId }),
    });
    const result = await res.json();
    return result.success ? result.folderId : null;
  } catch {
    return null;
  }
}

// Reads a browser File as base64 (no data: prefix), for edge-function upload.
export function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(',')[1] || '');
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}
